import { useEffect, useState } from "react";
import Body from "./components/Body/Body";
import Footer from "./components/Footer/Footer";
import Top from "./components/Top/Top";
import { pagination } from "./funtions/pagination";
import { ContainerTableGlobal } from "./localSyle";

const Table = ({ config, onChange }) => {
  //#region ------ useStates --------
  const [global, setGlobal] = useState({
    data: config.data, // lista de datos primaria
    dataFiltered: config.data, // lista filtrada
    dataSelected: [], // data seleccionada por usuario
    filter: [], // lista de filtros
    pagination: pagination(config.data, config.paginationView), // lista de arrays
    indexPagination: 0,
    paginationView: config.paginationView,
    clientX: 0,
    indexMove: false,
    copyLenCol: { all: config.width / config.column.length },
    column: config.column,
    agrupamietoColumn: [],
    cursorItemSelected: 0,
  });

  //#endregion --- useStates --------

  //#region ------ constants --------

  //#endregion --- constants --------

  //#region ------ useEffects --------
  useEffect(() => {
    setGlobal({
      ...global,
      data: config.data,
      dataFiltered: config.data,
      pagination: pagination(config.data, config.paginationView), // lista de arrays
    });
  }, [config]);

  useEffect(() => {
    window.onkeydown = shorcuts;
  }, []);

  useEffect(() => {
    if(onChange){
      onChange(global.dataSelected); 
    }
  },[global.dataSelected])

  //#endregion --- useEffects --------

  //#region ------ funciones --------
  const shorcuts = (e) => {
    const key = e.key.toLowerCase();
    const ctrl = e.ctrlKey;
    const lista = global.pagination[global.paginationView];

    if (key === "f" && ctrl) {
      e.preventDefault();
      const input = document.querySelector("#buscador-tabla-por-defecto");
      input.focus();
    }
  };
  //#endregion --- funciones --------

  return (
    <ContainerTableGlobal width={config.width}>
      <Top global={global} setGlobal={setGlobal} config={config} />

      <Body global={global} setGlobal={setGlobal} />

      <Footer global={global} setGlobal={setGlobal} />
    </ContainerTableGlobal>
  );
};

export default Table;
